import React, { Component } from 'react';
import { isIOS } from 'react-device-detect';

// eslint-disable-next-line
import style from './_style.css';

const converToNumber = (v) => {
    try {
        const f = v.getUint8(0).toString(16),
            s = v.getUint8(1).toString(16),
            t = v.getUint8(2).toString(16),
            e = v.getInt8(3);
        const hexa = `${t}${s}${f}`;
        if (hexa === '7FFFFF') {
            return undefined;
        } else {
            return Math.round(parseInt(hexa, 16) * Math.pow(10, e) * 10) / 10;
        }
    } catch (error) {
        return 'Err';
    }
};

class Bluetooth extends Component {
    state = {
        value: undefined,
    };

    UNSAFE_componentWillMount() {
        this.startBluetooth();
    }

    componentWillUnmount() {
        if (this.id) {
            clearInterval(this.id);
            this.id = undefined;
        }
    }

    startBluetooth = (event) => {
        if (window.device && window.characteristic && window.device.gatt.connected) {
            this.launchRead(window.characteristic);
        } else {
            this.findBluetooth(window.device)
                .then((d) => {
                    console.log(d);
                    this.connectDeviceAndCacheCharacteristics(d, window.characteristic).then(
                        (c) => {
                            window.characteristic = c;
                            if (c) {
                                this.launchRead(c);
                            }
                        },
                    );
                })
                .catch((error) => console.error(error));
        }
    };

    launchRead = (c) => {
        this.id = setInterval(() => {
            c.readValue().then((v) => {
                const value = converToNumber(v);
                this.props.onChange(value);
                this.setState({ value: value });
            });
        }, 500);
    };

    findBluetooth = (device) => {
        var known_service = 'f2b32c77-ea68-464b-9cd7-a22cbffb98bd';
        if (!navigator || !navigator.bluetooth) {
            return undefined;
        } else if (device && device.gatt.connected) {
            return device;
        } else {
            return navigator.bluetooth
                .requestDevice({
                    filters: [{ services: [known_service] }, { name: 'Blue2' }],
                })
                .then((device) => {
                    window.device = device;
                    return device;
                });
        }
    };

    connectDeviceAndCacheCharacteristics = (device, characteristic) => {
        if (device && device.gatt && device.gatt.connected && characteristic) {
            return characteristic;
        } else if (!device || !device.gatt) {
            return undefined;
        }
        return device.gatt
            .connect()
            .then((server) => {
                return server.getPrimaryService('f2b32c77-ea68-464b-9cd7-a22cbffb98bd');
            })
            .then((service) => {
                //number
                return service.getCharacteristic('fe50b198-5137-4b83-a266-6181e088d395');
            })
            .then((characteristic) => {
                return characteristic;
            })
            .catch((error) => {
                console.log(error);
            });
    };

    render() {
        const { value } = this.state;
        if (isIOS) {
            return <div className={'barlow_semibold c_white center '}>{`N/A`}</div>;
        } else {
            return (
                <div className={'barlow_semibold c_white center '}>
                    {value && `${value} ºC`}
                    {!value && `- ºC`}
                </div>
            );
        }
    }
}

export default Bluetooth;



// WEBPACK FOOTER //
// ./src/components/inputs/Bluetooth.js